import { absolutePath } from "./absolutePath";

export const cancellationSurvey = {
  config: (schema?: string) =>
    absolutePath("cancellation_survey/config", schema ? { schema } : {}),
  valueStats: () => absolutePath("cancellation_survey/value_stats"),
  evaluateOffer: () => absolutePath("cancellation_survey/offer/evaluate"),
  acceptOffer: () => absolutePath("cancellation_survey/offer/accept"),
};
